export default __webpack_public_path__ + "dfb1bcf25dc79f79f37d6c3b808a8d37.png";